import lodash from 'lodash'

import image from '../../assets/single_mini.svg'
import type { IItemProps } from '../../listTypes'
import * as s from './ListImage.module.scss'

const ListImage: React.FC<IItemProps> = ({ styles, path }) => {
  const bgColor = !styles.backgroundImage && !path ? 'backgroundColor' : ''
  return (
    <div
      className={s.root}
      style={{
        ...lodash.omit(styles, ['backgroundImage', bgColor]),
      }}
    >
      {!styles.backgroundImage && !path ? (
        <img alt='' src={image} aria-hidden/>
      ) : (
        <div
          className={s.image}
          style={{
            backgroundImage: path ? `url(${path})` : styles.backgroundImage,
            backgroundSize: styles.backgroundSize,
          }}
        />
      )}
    </div>
  )
}

export default ListImage
